export const sxStyle = {
  paper: {
    p: { xs: 1.25, sm: 2.5 },
    minWidth: { xs: '70%', sm: '35%' },
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },
  title: {
    fontSize: { xs: 16, sm: 24 },
    fontWeight: { xs: 600, sm: 700 },
    textAlign: 'center',
    color: 'black',
  },
  subtitle: {
    fontSize: { xs: 12, sm: 20 },
    textAlign: 'center',
    mt: 0,
    mb: { xs: 0, sm: 1.25 },
  },
  button: {
    fontSize: 18,
    fontWeight: { xs: 600, sm: 700 },
    p: { xs: '8px 16px', sm: '10px 20px' },
  },
  actions: {
    justifyContent: 'center',
  },
};
